module.exports = __webpack_public_path__ + "static/media/mytv-logo.be601ba9.png";